import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/staging/app/contexts/AuthProviderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "/var/app/staging/app/contexts/ConfigContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/app/staging/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/staging/components/AlreadySub.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/staging/components/LoginSuccess.tsx");
;
import(/* webpackMode: "eager" */ "/var/app/staging/node_modules/next/font/google/target.css?{\"path\":\"app/(with-metadata)/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
